var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "CardBase",
        [
          _c(
            "MacroSubHeader",
            { attrs: { title: "Agenda", icon: "el-icon-notebook-1" } },
            [
              _c("template", { slot: "actions" }, [
                _c(
                  "div",
                  [
                    _vm.isAuthorized
                      ? _c(
                          "el-button",
                          {
                            attrs: {
                              size: "small",
                              type: "primary",
                              plain: ""
                            },
                            on: { click: _vm.goToScheduleParameters }
                          },
                          [
                            _c("i", { staticClass: "el-icon-setting" }),
                            _vm._v(
                              "\n                        Configurar Parâmetros\n                    "
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "el-popover",
                      {
                        attrs: {
                          placement: "bottom-end",
                          width: "200",
                          trigger: "click"
                        }
                      },
                      [
                        _c(
                          "el-button",
                          {
                            staticClass: "mr-2",
                            attrs: {
                              slot: "reference",
                              size: "small",
                              plain: ""
                            },
                            slot: "reference"
                          },
                          [
                            _c("i", { staticClass: "el-icon-notebook-1" }),
                            _vm._v(
                              "\n                            Exportar Agenda\n                            "
                            ),
                            _c("i", { staticClass: "el-icon-arrow-down" })
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "d-flex flex-column",
                            style: { gap: "4px" }
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "flex-grow-1" },
                              [
                                _c(
                                  "el-button",
                                  {
                                    staticClass: "text-left",
                                    style: { width: "100%" },
                                    attrs: { plain: "" },
                                    on: {
                                      click: function($event) {
                                        return _vm.exportarAgendaParaPdf(
                                          "CALENDAR"
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _c("i", { staticClass: "el-icon-date" }),
                                    _vm._v(
                                      "\n                                    Calendário\n                                "
                                    )
                                  ]
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "flex-grow-1" },
                              [
                                _c(
                                  "el-button",
                                  {
                                    staticClass: "text-left",
                                    style: { width: "100%" },
                                    attrs: { plain: "" },
                                    on: {
                                      click: function($event) {
                                        return _vm.exportarAgendaParaPdf("LIST")
                                      }
                                    }
                                  },
                                  [
                                    _c("i", { staticClass: "el-icon-tickets" }),
                                    _vm._v(
                                      "\n                                Lista\n                            "
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          ]
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("EventsExportReports")
                  ],
                  1
                )
              ])
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 18 } },
                [
                  _c(
                    "CardBase",
                    { attrs: { border: "border-right" } },
                    [
                      _c(
                        "el-row",
                        [
                          _c(
                            "el-form",
                            {
                              staticClass: "mb-3",
                              attrs: { "label-position": "top" }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "d-flex justify-content-between",
                                  style: { gap: "12px" }
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "d-flex align-items-center",
                                      style: { gap: "20px" }
                                    },
                                    [
                                      _c(
                                        "el-button",
                                        {
                                          attrs: {
                                            size: "small",
                                            plain: "",
                                            round: ""
                                          },
                                          on: { click: _vm.goToday }
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "el-icon-sunny"
                                          }),
                                          _vm._v(
                                            "\n                                        Hoje\n                                    "
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "d-flex align-items-center",
                                          style: { gap: "20px" }
                                        },
                                        [
                                          _c(
                                            "el-button",
                                            {
                                              staticClass: "border-0",
                                              attrs: {
                                                size: "small",
                                                circle: ""
                                              },
                                              on: { click: _vm.goPrev }
                                            },
                                            [
                                              _c("i", {
                                                staticClass:
                                                  "el-icon-arrow-left"
                                              })
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "h5",
                                            {
                                              staticClass:
                                                "mb-0 font-weight-bolder"
                                            },
                                            [_vm._v(_vm._s(_vm.calendarTitle))]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "el-button",
                                            {
                                              staticClass: "border-0",
                                              attrs: {
                                                size: "small",
                                                circle: ""
                                              },
                                              on: { click: _vm.goNext }
                                            },
                                            [
                                              _c("i", {
                                                staticClass:
                                                  "el-icon-arrow-right"
                                              })
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "d-flex align-items-center",
                                      style: { gap: "12px" }
                                    },
                                    [
                                      _c(
                                        "el-select",
                                        {
                                          attrs: {
                                            size: "small",
                                            placeholder: "Selecionar status",
                                            filterable: "",
                                            clearable: ""
                                          },
                                          on: {
                                            change: function($event) {
                                              return _vm.fetch()
                                            }
                                          },
                                          model: {
                                            value: _vm.filters.status,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.filters,
                                                "status",
                                                $$v
                                              )
                                            },
                                            expression: "filters.status"
                                          }
                                        },
                                        [
                                          _c(
                                            "el-option",
                                            { attrs: { value: null } },
                                            [_vm._v("Todos")]
                                          ),
                                          _vm._v(" "),
                                          _vm._l(_vm.status, function(stat) {
                                            return _c(
                                              "el-option",
                                              {
                                                key: stat.value,
                                                attrs: { value: stat.value }
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "d-flex align-items-center"
                                                  },
                                                  [
                                                    stat.value != null
                                                      ? _c("el-tag", {
                                                          staticClass:
                                                            "rounded-circle mr-2",
                                                          style: {
                                                            width: "20px"
                                                          },
                                                          attrs: {
                                                            type: _vm.getEventColorByStatus(
                                                              stat.value
                                                            ),
                                                            size: "mini"
                                                          }
                                                        })
                                                      : _vm._e(),
                                                    _vm._v(
                                                      "\n                                                " +
                                                        _vm._s(stat.text) +
                                                        "\n                                            "
                                                    )
                                                  ],
                                                  1
                                                )
                                              ]
                                            )
                                          })
                                        ],
                                        2
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "el-button",
                                        {
                                          attrs: {
                                            size: "small",
                                            type: "primary",
                                            round: "",
                                            disabled: _vm.isLoading
                                          },
                                          on: {
                                            click: _vm.handleDateClickByAction
                                          }
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "el-icon-plus"
                                          }),
                                          _vm._v(
                                            "\n                                        Novo Evento\n                                    "
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ]
                              )
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-tabs",
                        {
                          attrs: { type: "border-card" },
                          on: { "tab-click": _vm.handleTabClick },
                          model: {
                            value: _vm.activeName,
                            callback: function($$v) {
                              _vm.activeName = $$v
                            },
                            expression: "activeName"
                          }
                        },
                        [
                          _c(
                            "el-tab-pane",
                            { attrs: { name: "first", lazy: "" } },
                            [
                              _c(
                                "span",
                                { attrs: { slot: "label" }, slot: "label" },
                                [
                                  _c("i", { staticClass: "el-icon-date" }),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "ml-1" }, [
                                    _vm._v("Calendário")
                                  ])
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "custom-calendar" },
                                [
                                  _c("FullCalendar", {
                                    ref: "fullCalendar",
                                    attrs: {
                                      options: _vm.finalCalendarOptions
                                    },
                                    scopedSlots: _vm._u([
                                      {
                                        key: "eventContent",
                                        fn: function(info) {
                                          return [
                                            _c(
                                              "el-button",
                                              {
                                                staticClass: "rounded-pill",
                                                style: {
                                                  width: "100%",
                                                  textAlign: "start"
                                                },
                                                attrs: {
                                                  size: "small",
                                                  plain: "",
                                                  type: _vm.getEventColorByStatus(
                                                    info.event.extendedProps
                                                      .status
                                                  )
                                                }
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "text-truncate"
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(info.event.title)
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          ]
                                        }
                                      }
                                    ])
                                  })
                                ],
                                1
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-tab-pane",
                            { attrs: { name: "second" } },
                            [
                              _c(
                                "span",
                                { attrs: { slot: "label" }, slot: "label" },
                                [
                                  _c("i", { staticClass: "el-icon-tickets" }),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "ml-1" }, [
                                    _vm._v("Lista")
                                  ])
                                ]
                              ),
                              _vm._v(" "),
                              _c("EventsSemanalView", {
                                attrs: {
                                  events: _vm.data,
                                  "reference-date": _vm.calendarDate
                                },
                                on: {
                                  dispatch: _vm.handleDispatch,
                                  handleEvent: _vm.handleEventClick
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c(
                    "CardBase",
                    { attrs: { size: "none" } },
                    [
                      _vm.isAuthorizedSearchSales
                        ? _c("CardBase", { staticClass: "relative" }, [
                            _c(
                              "div",
                              { staticClass: "d-flex align-items-center mb-3" },
                              [
                                _c("i", {
                                  staticClass: "el-icon-notebook-1 mr-2"
                                }),
                                _vm._v(" "),
                                _c(
                                  "h6",
                                  { staticClass: "mb-0 font-weight-bolder" },
                                  [_vm._v("Outras agendas")]
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "d-flex align-items-center" },
                              [
                                _c(
                                  "el-select",
                                  {
                                    attrs: {
                                      size: "small",
                                      placeholder: "Selecionar consultor",
                                      disabled: _vm.isLoading,
                                      filterable: ""
                                    },
                                    on: {
                                      change: function($event) {
                                        return _vm.fetch()
                                      }
                                    },
                                    model: {
                                      value: _vm.filters.consultant_user_id,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.filters,
                                          "consultant_user_id",
                                          $$v
                                        )
                                      },
                                      expression: "filters.consultant_user_id"
                                    }
                                  },
                                  _vm._l(_vm.sales, function(sale) {
                                    return _c("el-option", {
                                      key: sale.user_id,
                                      attrs: {
                                        label: sale.text,
                                        value: sale.user_id
                                      }
                                    })
                                  }),
                                  1
                                ),
                                _vm._v(" "),
                                _vm.filters.consultant_user_id
                                  ? _c(
                                      "el-button",
                                      {
                                        staticClass: "ml-2",
                                        attrs: {
                                          type: "danger",
                                          circle: "",
                                          plain: "",
                                          size: "mini"
                                        },
                                        nativeOn: {
                                          click: function($event) {
                                            $event.preventDefault()
                                            return _vm.handleConsultant()
                                          }
                                        }
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "el-icon-delete"
                                        })
                                      ]
                                    )
                                  : _vm._e()
                              ],
                              1
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c("CardBase", { attrs: { border: "border-top" } }, [
                        _c(
                          "div",
                          { staticClass: "d-flex justify-content-end" },
                          [
                            _c(
                              "el-dropdown",
                              {
                                attrs: {
                                  size: "mini",
                                  "split-button": "",
                                  plain: ""
                                },
                                on: { command: _vm.handleSetValuesOrder }
                              },
                              [
                                _c("strong", [_vm._v("Tipo")]),
                                _vm._v(
                                  ":  " +
                                    _vm._s(
                                      _vm.values_order == "monthly"
                                        ? "Mensal"
                                        : "Anual"
                                    ) +
                                    "\n                                "
                                ),
                                _c(
                                  "el-dropdown-menu",
                                  {
                                    attrs: { slot: "dropdown" },
                                    slot: "dropdown"
                                  },
                                  [
                                    _c(
                                      "el-dropdown-item",
                                      { attrs: { command: "monthly" } },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "d-flex align-items-center"
                                          },
                                          [
                                            _c("i", {
                                              staticClass: "el-icon-top mr-2"
                                            }),
                                            _vm._v(
                                              "\n                                            Mensal\n                                        "
                                            )
                                          ]
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "el-dropdown-item",
                                      { attrs: { command: "yearly" } },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "d-flex align-items-center"
                                          },
                                          [
                                            _c("i", {
                                              staticClass: "el-icon-bottom mr-2"
                                            }),
                                            _vm._v(
                                              "\n                                            Anual\n                                        "
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "d-flex flex-column",
                            style: { gap: "12px" }
                          },
                          [
                            _c(
                              "CardBase",
                              {
                                attrs: {
                                  border: ["border-left", "border-bottom"],
                                  radius: "small"
                                }
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "d-flex align-items-center justify-content-between"
                                  },
                                  [
                                    _c(
                                      "h6",
                                      { staticClass: "mb-0 font-weight-bold" },
                                      [_vm._v("Valor estimado")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          size: "small",
                                          type: "primary",
                                          plain: "",
                                          circle: ""
                                        }
                                      },
                                      [_c("i", { staticClass: "el-icon-coin" })]
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("h6", { staticClass: "mb-0" }, [
                                  _vm._v(
                                    "R$ " +
                                      _vm._s(
                                        _vm.getValor.valorEstimado
                                          .toString()
                                          .replace(".", ",")
                                      )
                                  )
                                ])
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "CardBase",
                              {
                                attrs: {
                                  border: "border-all",
                                  radius: "medium"
                                }
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "d-flex align-items-center justify-content-between"
                                  },
                                  [
                                    _c(
                                      "h6",
                                      { staticClass: "mb-0 font-weight-bold" },
                                      [_vm._v("Valor utilizado")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          size: "small",
                                          type: "success",
                                          plain: "",
                                          circle: ""
                                        }
                                      },
                                      [_c("i", { staticClass: "el-icon-coin" })]
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("h6", { staticClass: "mb-0" }, [
                                  _vm._v(
                                    "R$ " +
                                      _vm._s(
                                        _vm.getValor.valorUtilizado
                                          .toString()
                                          .replace(".", ",")
                                      )
                                  )
                                ])
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "CardBase",
                              {
                                attrs: {
                                  border: ["border-top", "border-right"],
                                  radius: "small"
                                }
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "d-flex align-items-center justify-content-between"
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "d-flex align-items-center",
                                        style: { gap: "12px" }
                                      },
                                      [
                                        _c(
                                          "h6",
                                          {
                                            staticClass: "mb-0 font-weight-bold"
                                          },
                                          [_vm._v("Valor não utilizado")]
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          size: "small",
                                          type: "danger",
                                          plain: "",
                                          circle: ""
                                        }
                                      },
                                      [_c("i", { staticClass: "el-icon-coin" })]
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("h6", { staticClass: "mb-0" }, [
                                  _vm._v(
                                    "R$ " +
                                      _vm._s(
                                        _vm.getValor.valorNaoUtilizado
                                          .toString()
                                          .replace(".", ",")
                                      )
                                  )
                                ])
                              ]
                            )
                          ],
                          1
                        )
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("EventCreateModal", {
        ref: "eventCreateModal",
        on: { created: _vm.handleDispatch }
      }),
      _vm._v(" "),
      _c("EventShowModal", {
        ref: "eventShowModal",
        on: { dispatch: _vm.handleDispatch }
      }),
      _vm._v(" "),
      _c(
        "EventsExportToPdf",
        {
          ref: "eventsExportToPdf",
          attrs: {
            date: _vm.calendarTitle,
            "user-schedule-name": _vm.selectedConsultantText,
            status: _vm.status,
            despesas: [
              {
                id: 1,
                text: "Viagem",
                icon: "el-icon-map-location"
              },
              {
                id: 2,
                text: "Hospedagem",
                icon: "el-icon-school"
              },
              {
                id: 3,
                text: "Almoço",
                icon: "el-icon-food"
              },
              {
                id: 4,
                text: "Jantar",
                icon: "el-icon-dish"
              }
            ]
          }
        },
        [
          _c(
            "template",
            { slot: "calendar" },
            [
              _vm.export_schedule_format == "CALENDAR"
                ? _c(
                    "div",
                    { staticClass: "custom-calendar" },
                    [
                      _c("FullCalendar", {
                        ref: "fullCalendarExport",
                        attrs: { options: _vm.finalCalendarOptions },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "eventContent",
                              fn: function(info) {
                                return [
                                  _c(
                                    "el-tag",
                                    {
                                      staticClass: "rounded-pill text-truncate",
                                      style: { width: "100%" },
                                      attrs: {
                                        size: "small",
                                        type: _vm.getEventColorByStatus(
                                          info.event.extendedProps.status
                                        )
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                            " +
                                          _vm._s(info.event.title) +
                                          "\n                        "
                                      )
                                    ]
                                  )
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          670211507
                        )
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.export_schedule_format == "LIST"
                ? _c("EventsSemanalView", {
                    attrs: {
                      events: _vm.data,
                      "reference-date": _vm.calendarDate,
                      isExport: true
                    },
                    on: {
                      dispatch: _vm.handleDispatch,
                      handleEvent: _vm.handleEventClick
                    }
                  })
                : _vm._e()
            ],
            1
          )
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-053ec1f4", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-053ec1f4","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/agenda/Index.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-053ec1f4","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/agenda/Index.vue
// module chunks = 2